import { Component, EventEmitter, Output, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { NotificationService } from '@core/services/notification/notification.service';
import { CiudadanoDatosService } from '@core/services/ciudadano/ciudadano-datos.service';
import { RoleService } from '@core/services/authentication/role.service';
import { AppRole } from '@core/enums/rol.enum';

@Component({
  selector: 'app-header-profile',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header-profile.component.html',
  styleUrls: ['./header-profile.component.scss'],
  host: {
    '[class.menu-open]': 'isMenuOpen',
  },
})
export class HeaderProfileComponent implements OnInit {
  readonly AppRole = AppRole;

  userName = '';
  notificationCount = 0;
  isMenuOpen = false;

  @Output('on-close-session') onCloseSessionEvent = new EventEmitter<void>();

  constructor(
    private $router: Router,
    private notificationService: NotificationService,
    private ciudadanoDatosService: CiudadanoDatosService,
    private roleService: RoleService,
    private cdr: ChangeDetectorRef
  ) {
    this.cargarNotificaciones();
    this.notificationService.unreadCount$.subscribe((count) => {
      this.notificationCount = count;
      this.cdr.markForCheck();
    });

    this.ciudadanoDatosService.getDatosGeneralesCiudadanoObservable().subscribe((datos) => {
      if (datos && datos.nombre) {
        const primerNombre = datos.nombre.split(' ')[0];
        this.userName = primerNombre.charAt(0).toUpperCase() + primerNombre.slice(1).toLowerCase();
      } else {
        this.userName = '';
      }
      this.cdr.markForCheck();
    });
  }

  ngOnInit(): void { }

  hasRole(role: AppRole): boolean {
    return this.roleService.hasRole(role);
  }

  hasAnyRole(roles: AppRole[]): boolean {
    return this.roleService.hasAnyRole(roles);
  }

  cargarNotificaciones(): void {
    this.notificationService.loadUnreadCount().subscribe({
      next: () => { },
      error: () => { },
    });
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    this.updateBodyClass();
  }

  closeMenu(route: string | null) {
    this.isMenuOpen = false;
    this.updateBodyClass();
    if (route) {
      this.$router.navigate(['app', route]);
    }
  }

  private updateBodyClass() {
    if (this.isMenuOpen) {
      document.body.classList.add('menu-open');
      document.body.style.overflow = 'hidden'; // Deshabilitar scroll
    } else {
      document.body.classList.remove('menu-open');
      document.body.style.overflow = ''; // Restaurar scroll
    }
  }

  onCloseSession() {
    this.onCloseSessionEvent.emit();
  }
}
